<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/sale/orders">{{ $t('sale_order') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="control-label blue">{{ $t('customer') }}</label>
                            <div>
                                <CustomerDropdown @select="customerSelected" :value="header.CustomerName"></CustomerDropdown>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label blue">{{ $t('date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="date" />
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                    <tr>
                                        <th style="width: 30px;"></th>
                                        <th>{{$t('item_name')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th v-if="permission==1" style="width: 100px;">{{$t('qty_in_stock')}}</th>
                                        <th style="width: 100px;">{{$t('qty_sale_order')}}</th>
                                        <th v-if="permission==1" style="width: 100px;">{{$t('cost')}}</th>
                                        <th style="width: 100px;">{{$t('price_sale')}}</th>
                                        <th v-if="permission==1" style="width: 100px;">{{$t('discount')}}</th>
                                        <th class="text-right" style="width: 100px;">{{$t('amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="ret.Id">
                                        <td style="width: 30px;">
                                            <button type="button" class="btn btn-danger btn-remove" @click="onRemove(index)">X</button>
                                        </td>
                                        <td><AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                        <td>
                                            <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                        </td>
                                        <td v-if="permission==1">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.QtyInStock" readonly />
                                        </td>
                                        <td class="text-center" :class="{'form-group-error': ret.Quantity>ret.QtyInStock}">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <td v-if="permission==1"><input type="number" class="form-control form-control-sm" v-model="ret.Cost" readonly /></td>
                                        <td class="text-right" :class="{'form-group-error': ret.Price<=ret.Cost}">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Price" @keypress="$isKeyNumber" @change="reCalculate" :disabled="permission !=1 || ret.ItemId==''">
                                        </td>
                                        <td class="text-right" v-if="permission==1">
                                            <div class="input-group">
                                                <input type="number"
                                                    class="form-control form-control-sm"
                                                    aria-describedby="dis-addon"
                                                    v-model="ret.Discount"
                                                    :disabled="ret.ItemId==''"
                                                    @keypress="$isKeyNumber"
                                                    @change="reCalculate">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="dis-addon" style="padding: 3px; width:30px; justify-content:center; cursor: pointer;" @click="onChangeDis(ret)">{{ret.DiscountType==1?'$':'%'}}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" readonly />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="2" rowspan="3" style="vertical-align: top;">
                                            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                        </td>
                                        <th :colspan="permission==1?6:3" class="text-right">{{$t('grand_total')}}:</th>
                                        <th class="text-right">{{$money(header.GrandTotal)}}</th>
                                    </tr>
                                    <tr v-if="permission==1">
                                        <th colspan="6" class="text-right">{{$t('discount')}}:</th>
                                        <th class="text-right">{{ $money(header.Discount) }}</th>
                                    </tr>
                                    <tr>
                                        <th :colspan="permission==1?6:3" class="text-right">{{$t('total')}}:</th>
                                        <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <br>
                    <hr>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="control-lable blue">{{ $t('noted') }}</label>
                                <div>
                                    <textarea class="form-control form-control-sm" v-model="header.Description"> </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import { CustomerDropdown } from '../Customer';
import UomDropdown from '../UOM/Dropdown';
export default {
    components: {
        AuthCompleted,
        CustomerDropdown,
        UomDropdown
    },
    data: function(){
        return {
            title: this.$t('sale_order_create'),
            header: {
                CustomerId: '',
                CustomerName: '',
                Phone: '',
                GrandTotal: 0,
                TaxVat: 0,
                PaidAmount: 0
            },
            lines: [{
                ItemId: '',
                ItemName: '',
                UomId: '',
                UomName: '',
                QtyInStock: 0,
                Quantity: 1,
                Cost: 0,
                Price: 0,
                Discount: 0,
                DiscountAmount: 0,
                DiscountType: 1,
                TaxLine: 0,
                SubTotal: 0
            }],
            date: this.$now().format('YYYY-MM-DD'),
        }
    },
    created(){
        let id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            let loading = this.$loading.show();
            this.$api().post('sale/order/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.title = this.$t('sale_order_update') +' ['+ this.header.Num + ']';
                }
            }).finally(function(){ loading.hide(); });
        }
    },
    methods: {
        addLine(){
            this.lines.push({
                ItemId: '',
                ItemName: '',
                UomId: '',
                UomName: '',
                QtyInStock: 0,
                Quantity: 1,
                Cost: 0,
                Price: 0,
                Discount: 0,
                DiscountAmount: 0,
                DiscountType: 1,
                TaxLine: 0,
                SubTotal: 0
            });
        },
        save(){
            if(this.lines.length > 0){
                let loading = this.$loading.show();
                this.header.Date = this.date;
                var req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post('sale/order/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/sale/orders');
                    }
                }).finally(function() { loading.hide();});
            }
        },
        customerSelected(evt){
            this.header.CustomerId = evt.Id;
            this.header.CustomerName = evt.Name;
            this.header.Phone = evt.Phone;
        },
        reCalculate(){
            let grand = 0;
            let totalDis = 0;
            let untax = 0;
            let totalVat = 0;
            let totalAmount = 0;
            this.lines.map(item => {
                let fieldDis = Number(item.Discount);
                let fieldPrice = Number(item.Price);
                let fieldQty = Number(item.Quantity);

                let discount = item.DiscountType == 1? fieldDis: fieldPrice * fieldDis / 100;
                let newPrice = fieldPrice - discount;
                let total = fieldQty * newPrice;
                let taxVat = total * (Number(item.TaxLine) / 100);
                let subTotal = total + taxVat;
                item.SubTotal = subTotal;
                totalDis += discount * fieldQty;
                untax += total;
                totalVat += taxVat;
                grand += fieldQty * fieldPrice;
                totalAmount += subTotal;
            });
            this.header.GrandTotal = grand;
            this.header.Discount = totalDis;
            this.header.UntaxAmount = untax;
            this.header.TaxVat = totalVat;
            this.header.PaidAmount = totalAmount;
        },
        itemSelect(evt, line){
            line.ItemId = evt.Id;
            line.ItemName = evt.Name;
            line.Price = evt.Price;
            line.UomId = evt.UomId;
            line.UomName = evt.UomName;
            line.QtyInStock = evt.EndingQty;
            line.Cost = evt.Cost;
            this.reCalculate();
        },
        onRemove(index){
            this.lines.splice(index, 1);
            this.reCalculate();
        },
        uomChange(e, line){
            line.UomId = e.UomId;
            line.UomName = e.UomName;
            line.Price = e.Price;
            line.Cost = e.Cost;
            this.reCalculate();
        },
        onChangeDis(line){
            if(line.DiscountType == 1) line.DiscountType = 2;
            else line.DiscountType = 1;
            if(line.ItemId !== '') this.reCalculate();
        }
    },
    computed: {
        permission(){
            return this.$store.state.userGroup;
        }
    }
}
</script>
